import editFileTemplate from "/WebInterface/new-ui/modules/modals/edit-file/template.js";
import Modal from "/WebInterface/new-ui/modules/modal.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";

export const initEditFile = async (file) => {
  const c2f = utils.cookie.get("currentAuth");

  const handleSubmit = async (dialog) => {
    const file_content = _$("#editFileTextArea").val();

    const loading = new Loader({});

    try {
      await ajax.call({
        data: {
          command: "savetext",
          file_content,
          upload_path: file.href_path,
          c2f,
        },
      });

      growl(t("fileSaved"), t("success"), 5000);
    } catch (error) {
      growl(t("somethingWentWrongWhileSavingTheFile"), t("error"), 3000, true);
    } finally {
      dialog.hide(true);
      loading.deleteLoader();
    }
  };

  const loading = new Loader({});

  try {
    //   handleSubmit(customFormDialog);
    const response = await ajax.call({
      data: {
        command: "download",
        mimeType: "plain/text",
        path: file.href_path,
        c2f,
      },
    });

    const content = typeof response === "string" ? response : "";

    const dialog = new Modal({
      title: "editAFile",
      body: editFileTemplate({ content }),
      uniqueId: "edit-file-modal",
      animate: false,
      movable: true,
      hasResizeOption: true,
      minWidth: "1200px",
      minHeight: "575px",
      buttons: [
        {
          label: "cancel",
          close: true,
          classes: ["mr-3", "is-bordered"],
          onClick: () => {},
        },
        {
          label: "save",
          close: false,
          classes: ["mr-3"],
          onClick: () => handleSubmit(dialog),
        },
      ],
    });
  } catch (error) {
    growl(t("somethingWentWrongWhileOpeningTheFile"), t("error"), 3000, true);
  } finally {
    loading.deleteLoader();
  }
};
